declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/products.scss';
import '../styles/frames.scss';

import { h, Component } from 'preact';

export default class Enterprisesolution extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {
      
      const calltoaction = <p class="center calltoaction"><a href={ BASE_URL + 'contacts' } class="butt huge">Contact us</a></p>;

        return <div id="enterprise" class="product">
          <div class="mainWrp">
            <section class="body center">
              <h1>Enterprise Solution</h1>
              <h2 class="content">
                Want to add an AI layer to your enterprise system?​
              </h2>
              { calltoaction }
            </section>
          </div>
          <div class="mainWrp frameWrp">
            <div class="col">
              <div class="frame ipad">
                <img class="frameImg" src={STATIC_BASE_URL + 'images/public/frame_ipad.png'} alt="Enterprise Solution" />
                <div class="inframeWrp">
                  <img class="inframe" src={ STATIC_BASE_URL + 'images/public/products-enterprise-solution-detail.png'} alt="Enterprise Solution" />
                </div>
              </div>
            </div>
            <div class="col padLeft">
              <h2>Querlo will help to make your organization smarter as a whole!​</h2>
              <p>
                Our powerful Lead Gen solution can convert higher percentage of your web traffic and produce stronger customer engagement.<br />
                Our solution can help lead customers through virtually every part of the sales funnel.
              </p>
              <p>
                From HR management to Knowledge Exchange, Querlo's Conversational AI solutions will empower your employees and inspire communications of stakeholders both internally and externally.
              </p>
            </div>
            <br style="clear:both" />
          </div>
          <section class="full grey">
              <p>
                Satisfied employees lead to higher productivity and quality work.​
              </p>
              <p>
                Unleash the power of the conversational AI to help you meet the needs of your employees. Make it faster and easier for them to get answers from your organization and giving them a helping hand through AI support. ​
              </p>
              <p>
                Our platform helps you automate daily tasks to free up your employees for more challenging work. Our solution also foster internal communication at your organization, to engage cross-department idea exchange, and to reward the most contributing individuals and departments. ​
              </p>
          </section>
          <section>
            <blockquote>
              84% of enterprises believe investing in AI will lead to greater competitive advantages.
              <span>Statista</span>
            </blockquote>
          </section>
          <section class="features center cols full">
            <div class="mainWrp">
              <h2>Benefits</h2>
              <div class="col">
                <div class="col first">
                  <h3><i class="fa fa-smile"></i> Happier Employees</h3>
                  <p>
                    Provide your employees with a 24/7 automated service. You can meet their needs faster and make their lives easier while boosting the productivity. ​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-magic"></i> Automation and organization</h3>
                  <p>
                    Schedule meetings, calls and appointments to save time and keep your daily tasks in routine. Additionally, employee on boarding can be extremely streamlined and efficient by an intelligent bot.​
                  </p>
                </div>
              </div>
              <div class="col">
                <div class="col">
                  <h3><i class="fa fa-user-astronaut"></i> Empower Employees</h3>
                  <p>
                    Solve common requests especially in the IT and HR department, so that your employees are free and can spend more time on complex requests.
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-network-wired"></i> Improve internal communication</h3>
                  <p>
                    Increase employee engagement with a personalized interaction. Foster cross-department communication through effective rewarding system and shared organizational knowledge library.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section class="features full center cols grey">
            <h2>Features</h2>
            <div class="mainWrp">
              <div class="col">
                <div class="col first">
                  <h3><i class="fa fa-language"></i> NLU</h3>
                  <p>
                    The Natural Language Understanding capability can create smooth conversation with powerful logic as keeping the human element in customer service while using AI and machine learning.
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-tape"></i> API Integration</h3>
                  <p>
                    The platform can integrate with most external APIs and internal ones to make the solution complete and tailored.​
                  </p>
                </div>
              </div>
              <div class="col">
                <div class="col">
                  <h3><i class="fa fa-cogs"></i> Seamless workspace integration</h3>
                  <p>
                    Compatible with most popular workspace, Sharepoint, Slack, etc.​
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-swatchbook"></i> Highly customizable</h3>
                  <p>
                    The product is easily adaptable and customizable. We also deliver bespoke solutions to meet your unique business needs. ​
                  </p>
                </div>
              </div>
            </div>
            <div class="mainWrp">
              <div class="col allalone">
                <div class="col">
                  <h3><i class="fa fa-chart-bar"></i> Analytics</h3>
                  <p>
                    Powerful analytics to show you insights of business performance and identify points of improvement.
                  </p>
                </div>
                <div class="col">
                  <h3><i class="fa fa-address-book"></i> CRM integration</h3>
                  <p>
                    We generate CRM insights to support your business decision making.
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section>
              { calltoaction }
          </section>
        </div>
    }
}


// WEBPACK FOOTER //
// ./ts/Enterprisesolution.tsx